export function setCurrentUser(payload) {
    return { type: 'CURRENT_USER_SET', payload }
}

export function setCurrentUserProfile(payload) {
    return { type: 'CURRENT_USER_PROFILE_SET', payload }
}

export function setAccessToken(payload) {
    return { type: 'ACCESS_TOKEN_SET', payload }
}

export function setCurrentLoyaltyMemberDetail(payload) {
    return { type: 'CURRENT_LOYALTY_MEMBER_DETAIL_SET', payload }
}

